import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Accordion } from 'react-bootstrap';
import { FaCheck, FaArrowRight } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Services.css';

const Services: React.FC = () => {
  const [activeKey, setActiveKey] = useState('0');

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  const services = [
    {
      id: '0',
      title: 'Roscas Transportadoras',

      description: 'Recondicionamento completo com revestimento duro específico para cada aplicação.',
      details: [
        'Recondicionamento inteiramente',
        'Colocação nas medidas originais',
        'Aplicação de revestimento duro',
        'Específico para cada aplicação',
        'Testes de qualidade rigorosos',
        'Garantia de durabilidade'
      ]
    },
    {
      id: '1',
      title: 'Tambor e Eixos',

      description: 'Recondicionamento de rotores e eixos com metalização e balanceamento eletrônico.',
      details: [
        'Recondicionamento de conjuntos de rotores',
        'Aplicações de metalização nos colos',
        'Retentores de vedação',
        'Alinhamento de precisão',
        'Balanceamento eletrônico',
        'Controle de qualidade avançado'
      ]
    },
    {
      id: '2',
      title: 'Redutores',

      description: 'Recondicionamento de caixas de engrenagens e cicloredutores de centrifugas.',
      details: [
        'Recondicionamento de caixa de engrenagens',
        'Cicloredutores de centrifugas decantadoras',
        'Fornecimento de redutores novos',
        'Substituição de componentes',
        'Manutenção preventiva',
        'Análise técnica especializada'
      ]
    },
    {
      id: '3',
      title: 'Decanters',

      description: 'Locação, venda e recondicionamento completo de centrifugas decantadoras.',
      details: [
        'Locação de centrifugas decantadoras',
        'Venda de centrifugas novas e semi-novas',
        'Recondicionamento completo',
        'Melhorias e modificações de projeto',
        'Adequação para aplicação específica',
        'Suporte técnico especializado'
      ]
    }
  ];

  const benefits = [
    {
      title: 'Experiência Comprovada',
      description: 'Mais de 25 anos de experiência no ramo industrial.',
      icon: <FaCheck />
    },
    {
      title: 'Qualidade Garantida',
      description: 'Todos os nossos serviços possuem garantia de qualidade.',
      icon: <FaCheck />
    },
    {
      title: 'Atendimento Nacional',
      description: 'Atendemos clientes em diversos estados do Brasil.',
      icon: <FaCheck />
    },
    {
      title: 'Suporte Técnico',
      description: 'Equipe técnica especializada para suporte completo.',
      icon: <FaCheck />
    }
  ];

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="page-hero">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8} data-aos="fade-up">
              <h1>Nossos Serviços</h1>
              <p>
                Serviços especializados em Decanters de quaisquer marca ou procedência, 
                aplicada em diversas atividades industriais.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Services Accordion */}
      <section className="section services-accordion-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10}>
              <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key as string)}>
                {services.map((service, index) => (
                  <Accordion.Item key={service.id} eventKey={service.id} data-aos="fade-up" data-aos-delay={index * 100}>
                    <Accordion.Header>
                      <div className="service-header">
                        <div className="service-icon">
                          <FaCheck />
                        </div>
                        <div className="service-info">
                          <h3>{service.title}</h3>
                          <p>{service.description}</p>
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="service-details">
                        <Row>
                          <Col lg={8}>
                            <h4>Detalhes do Serviço</h4>
                            <ul className="service-features">
                              {service.details.map((detail, idx) => (
                                <li key={idx}>
                                  <FaCheck className="check-icon" />
                                  <span>{detail}</span>
                                </li>
                              ))}
                            </ul>
                          </Col>
                          <Col lg={4}>
                            <div className="service-cta">
                              <h5>Solicitar Orçamento</h5>
                              <p>Entre em contato para um orçamento personalizado</p>
                              <a href="/contato" className="btn btn-primary">
                                Solicitar Orçamento
                                <FaArrowRight className="ms-2" />
                              </a>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Benefits Section */}
      <section className="section benefits-section">
        <Container>
          <div className="section-title" data-aos="fade-up">
            <h2>Por que escolher a MR Centrifugas?</h2>
            <p>Conheça os diferenciais que nos tornam referência no mercado</p>
          </div>
          
          <Row>
            {benefits.map((benefit, index) => (
              <Col lg={3} md={6} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                <Card className="benefit-card">
                  <Card.Body>
                    <div className="benefit-icon">
                      <FaCheck />
                    </div>
                    <Card.Title>{benefit.title}</Card.Title>
                    <Card.Text>{benefit.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Process Section */}
      <section className="section process-section">
        <Container>
          <div className="section-title" data-aos="fade-up">
            <h2>Nosso Processo de Trabalho</h2>
            <p>Metodologia estruturada para garantir a qualidade dos nossos serviços</p>
          </div>
          
          <Row>
            <Col lg={3} md={6} data-aos="fade-up" data-aos-delay={100}>
              <div className="process-step">
                <div className="step-number">1</div>
                <h4>Análise Técnica</h4>
                <p>Avaliação detalhada do equipamento e identificação das necessidades específicas.</p>
              </div>
            </Col>
            <Col lg={3} md={6} data-aos="fade-up" data-aos-delay={200}>
              <div className="process-step">
                <div className="step-number">2</div>
                <h4>Orçamento</h4>
                <p>Elaboração de orçamento detalhado com cronograma e especificações técnicas.</p>
              </div>
            </Col>
            <Col lg={3} md={6} data-aos="fade-up" data-aos-delay={300}>
              <div className="process-step">
                <div className="step-number">3</div>
                <h4>Execução</h4>
                <p>Realização do serviço com acompanhamento técnico e controle de qualidade.</p>
              </div>
            </Col>
            <Col lg={3} md={6} data-aos="fade-up" data-aos-delay={400}>
              <div className="process-step">
                <div className="step-number">4</div>
                <h4>Entrega</h4>
                <p>Entrega do equipamento com testes finais e documentação técnica completa.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8} data-aos="fade-up">
              <h2>Precisa de um orçamento?</h2>
              <p>
                Nossa equipe está pronta para atender você e fornecer a melhor solução 
                para suas necessidades. Entre em contato conosco.
              </p>
              <div className="cta-buttons">
                <a href="/contato" className="btn btn-primary btn-lg me-3">
                  Solicitar Orçamento
                </a>
                <a href="tel:+5511997808507" className="btn btn-outline-primary btn-lg">
                  Ligar Agora
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Services; 